import type { NilHundredResponse } from '@on3/api';
import {
  formatCurrency,
  formatMillions,
} from '@on3/ui-lib/src/utils/formatters';
import { SportIcon } from 'components/Icons/SportIcon';
import { On3Avatar } from 'components/Image/On3Avatar';
import { Link } from 'components/Link';
import { CommitStatusNIL } from 'components/RecruitmentStatus/AlternativeView/CommitStatusNIL';
import { StarRating } from 'components/UI/StarRating/StarRating';

import { divisionAbbreviation, getNILProfileLink } from './helpers';
import styles from './Nil100ModuleItems.module.scss';

interface INil100ModuleItemsProps extends NilHundredResponse {
  itemClassName?: string;
}

export const Nil100ModuleItems = ({
  person,
  valuation,
}: INil100ModuleItemsProps) => {
  if (!person) {
    return null;
  }

  const {
    classYear,
    defaultAsset,
    division,
    slug,
    name,
    defaultSport,
    positionAbbreviation,
    rating,
    highSchool,
    homeTownName,
  } = person;

  const profileLink = getNILProfileLink({
    sport: defaultSport?.name,
    slug,
  });

  return (
    <li className={styles.block}>
      <span className={styles.rank}>{valuation?.rank}</span>

      <On3Avatar
        altText={defaultAsset?.title ?? 'player headshot'}
        className={styles.avatar}
        domain={defaultAsset?.domain}
        height={50}
        source={defaultAsset?.source}
        title={defaultAsset?.title ?? ''}
        width={50}
      />

      <div className={styles.meta}>
        <div className={styles.nameYear}>
          <Link className={styles.name} href={profileLink}>
            {name}
          </Link>
          <span className={styles.year}>{classYear}</span>
        </div>
        <div className={styles.location}>
          <Link href={`/high-school/${highSchool?.urlSlug}/`}>
            {highSchool?.name}
          </Link>
          <span>{homeTownName}</span>
        </div>
        <StarRating
          isConsensus
          rating={rating?.consensusRating}
          stars={rating?.consensusStars}
        />
      </div>

      <div className={styles.divisionPosition}>
        <span className={styles.division}>
          {division ? divisionAbbreviation(division) : 'NA'}
        </span>
        <div className={styles.position}>
          <SportIcon sportName={defaultSport?.name} />
          <span>{positionAbbreviation}</span>
        </div>
      </div>

      <div className={styles.status}>
        <CommitStatusNIL {...person} />
      </div>

      <div className={styles.stats}>
        <span className={styles.valuation}>
          {valuation?.valuation ? formatCurrency(valuation?.valuation) : '-'}
        </span>
        <span className={styles.followers}>
          {valuation?.followers ? formatMillions(valuation?.followers) : '-'}
          <br />
          followers
        </span>
      </div>
    </li>
  );
};
